import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.586 4.1a3.757 3.757 0 1 1 5.313 5.314l-3.036 3.037a2.476 2.476 0 1 1-3.501-3.502l2.244-2.244a.7.7 0 0 1 .99.99L10.35 9.94a1.076 1.076 0 1 0 1.522 1.522l3.036-3.037a2.357 2.357 0 1 0-3.333-3.333L5.09 11.576a2.357 2.357 0 1 0 3.333 3.333l1.143-1.142a.7.7 0 1 1 .99.99l-1.143 1.142a3.757 3.757 0 1 1-5.313-5.313L10.586 4.1Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
